import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const beSaveCashupReconcile = actionBe('beSaveCashupReconcile', ({ AT, ATAG, data }) =>
  endpoint(H.post, 'cashup/:salonId/reconcile', {
    base: CONF.transactionApiRoot,
    AT,
    name: ATAG,
    data,
  }),
);

export default beSaveCashupReconcile;
